module.exports = __webpack_public_path__ + "static/thumb-renta-salon-ff0414b0df64b612cc0dadd2d29b8acd.jpg";